/* LOFTfifty6 — productpagina voor vloerkleden (Passe Partout Rugs Collection).

   Bouwt twee dingen op uit het JSON-blok van snippets/lf-kleed-data.liquid:
   de klikbare kleurstalen en de maatknoppen met de prijs erop.

   Wat het bewust NIET doet: prijzen uitrekenen. Elke prijs komt uit de variant
   die Shopify heeft meegegeven. Zodra hier zou worden opgeteld of afgetrokken,
   kan de pagina een ander bedrag tonen dan de winkelwagen rekent. De prijs op
   een maatknop is dus geen berekening maar een opzoeking: de goedkoopste
   bestaande variant met die maat. Bij deze collectie is dat tevens de enige,
   want binnen een maat kost elke kleur hetzelfde.

   Het bestellen gaat via een gewone formulierverzending naar /cart/add. Dat is
   met opzet, net als bij lf-stoel.js: zo hangt de belangrijkste knop van de
   pagina niet af van een fetch-aanroep of van de winkelwagenlade van het thema.

   Anders dan bij de stoel zijn kleur én maat echte productopties. Er gaan hier
   dus geen properties mee; een klik kiest gewoon een variant. */

(function () {
  'use strict';

  document.querySelectorAll('[data-lf-kleed]').forEach(start);

  function start(wortel) {
    var bron = wortel.querySelector('[data-lf-kleed-data]');
    if (!bron) return;

    var data;
    try {
      data = JSON.parse(bron.textContent);
    } catch (fout) {
      // Liever een lege configurator met een melding dan een halve pagina.
      console.error('lf-kleed: gegevens onleesbaar', fout);
      return;
    }
    if (!data.varianten || !data.varianten.length) return;

    var iKleur = data.opties.kleur;
    var iMaat = data.opties.maat;
    if (iKleur < 0 || iMaat < 0) return;

    var geld = maakGeld(data.valuta, data.taal);

    var el = {
      stalen: wortel.querySelector('[data-lf-stalen]'),
      maten: wortel.querySelector('[data-lf-maten]'),
      kaart: wortel.querySelector('[data-lf-kaart]'),
      kaartBeeld: wortel.querySelector('[data-lf-kaart-beeld]'),
      kaartNaam: wortel.querySelector('[data-lf-kaart-naam]'),
      kaartMeta: wortel.querySelector('[data-lf-kaart-meta]'),
      kaartLoep: wortel.querySelector('[data-lf-kaart-loep]'),
      gekozenKleur: wortel.querySelector('[data-lf-gekozen="kleur"]'),
      gekozenMaat: wortel.querySelector('[data-lf-gekozen="maat"]'),
      prijs: wortel.querySelector('[data-lf-prijs]'),
      totaal: wortel.querySelector('[data-lf-totaal]'),
      mobielTotaal: wortel.querySelector('[data-lf-mobiel-totaal]'),
      mobiel: wortel.querySelector('[data-lf-mobiel]'),
      variantId: wortel.querySelector('[data-lf-variant-id]'),
      samenvatting: wortel.querySelector('[data-lf-samenvatting]'),
      bestel: wortel.querySelector('[data-lf-bestel]'),
      melding: wortel.querySelector('[data-lf-melding]'),
      hoofdbeeld: wortel.querySelector('[data-lf-hoofdbeeld]'),
      strip: wortel.querySelector('[data-lf-strip]'),
      combiKleurStaal: wortel.querySelector('[data-lf-combi-kleur-staal]'),
      combiKleurNaam: wortel.querySelector('[data-lf-combi-kleur-naam]'),
      combiMaatNaam: wortel.querySelector('[data-lf-combi-maat-naam]'),
      laag: wortel.querySelector('[data-lf-laag]'),
      laagBeeld: wortel.querySelector('[data-lf-laag-beeld]'),
      laagNaam: wortel.querySelector('[data-lf-laag-naam]'),
      laagSluit: wortel.querySelector('[data-lf-laag-sluit]'),
      form: wortel.querySelector('[data-lf-form]')
    };

    var kleuren = data.kleuren || [];
    var maten = data.maten || [];

    // Tweede bron voor het staal: de afbeelding die in Shopify aan de variant
    // hangt. De eerste bron is de productfoto met alt-tekst "kleurstaal <Kleur>".
    // Zo blijft een tegel gevuld ook als die alt-tekst ooit wordt aangepast —
    // dan valt hij terug op wat er aan de variant zelf is gekoppeld.
    kleuren.forEach(function (kleur) {
      if (kleur.foto) return;
      for (var i = 0; i < data.varianten.length; i++) {
        var v = data.varianten[i];
        if (v.waarden[iKleur] === kleur.waarde && v.beeld) {
          kleur.foto = v.beeld;
          kleur.groot = kleur.groot || v.beeld;
          return;
        }
      }
    });
    var keuze = { kleur: null, maat: null };
    var knoppenKleur = [];
    var knoppenMaat = [];
    // Het hoofdbeeld volgt de kleur pas ná een klik. Bij het laden blijft het
    // sfeerbeeld staan: dat is de vaste afspraak over de hoofdfoto, en anders
    // zou de pagina bij elke opening zichtbaar omspringen naar een packshot.
    var geklikt = false;

    /* ---------- opzoeken in de varianten ---------- */

    function variantVoor(kleur, maat) {
      for (var i = 0; i < data.varianten.length; i++) {
        var v = data.varianten[i];
        if (v.waarden[iKleur] === kleur && v.waarden[iMaat] === maat) return v;
      }
      return null;
    }

    // Goedkoopste bestaande variant met deze maat. Binnen een maat kost elke
    // kleur hetzelfde, dus dit is in de praktijk gewoon "de prijs van die maat".
    function prijsVanMaat(maat) {
      var laagste = null;
      for (var i = 0; i < data.varianten.length; i++) {
        var v = data.varianten[i];
        if (v.waarden[iMaat] !== maat) continue;
        if (laagste === null || v.prijs < laagste) laagste = v.prijs;
      }
      return laagste;
    }

    // Bestaat er bij deze kleur überhaupt een leverbare maat (en andersom)?
    // Zo blijft een combinatie die Shopify niet kent zichtbaar maar uitgezet.
    function heeftIets(index, waarde) {
      for (var i = 0; i < data.varianten.length; i++) {
        if (data.varianten[i].waarden[index] === waarde) return true;
      }
      return false;
    }

    function kleurGegevens(naam) {
      for (var i = 0; i < kleuren.length; i++) {
        if (kleuren[i].waarde === naam) return kleuren[i];
      }
      return { waarde: naam, foto: null, groot: null, alt: naam };
    }

    /* ---------- kleurstalen ---------- */

    function bouwStalen() {
      if (!el.stalen) return;
      el.stalen.textContent = '';
      knoppenKleur = [];

      kleuren.forEach(function (kleur) {
        var knop = document.createElement('button');
        knop.type = 'button';
        knop.className = 'lf-kleed-staal';
        knop.setAttribute('aria-pressed', 'false');
        // De naam staat niet zichtbaar op de tegel (dat maakt het raster druk),
        // dus hij moet er wel als toegankelijke naam op zitten.
        knop.setAttribute('aria-label', kleur.waarde);
        knop.dataset.waarde = kleur.waarde;

        if (kleur.foto) {
          var beeld = document.createElement('img');
          beeld.src = kleur.foto;
          beeld.alt = '';
          beeld.loading = 'lazy';
          beeld.width = 160;
          beeld.height = 160;
          knop.appendChild(beeld);
        } else {
          // Nog geen staalfoto in Drive: naamtegel in plaats van een gebroken
          // afbeelding. De kleur blijft gewoon te kiezen en te bestellen.
          var vlak = document.createElement('span');
          vlak.className = 'lf-kleed-staal__geen';
          vlak.textContent = kleur.waarde;
          knop.appendChild(vlak);
        }

        var vink = document.createElement('span');
        vink.className = 'lf-kleed-staal__vink';
        vink.setAttribute('aria-hidden', 'true');
        vink.innerHTML = '<svg viewBox="0 0 24 24"><path d="m5 13 4 4 10-10"/></svg>';
        knop.appendChild(vink);

        if (!heeftIets(iKleur, kleur.waarde)) {
          knop.dataset.uit = 'true';
          knop.disabled = true;
        }

        knop.addEventListener('click', function () {
          if (knop.disabled) return;
          keuze.kleur = kleur.waarde;
          geklikt = true;
          teken();
        });

        el.stalen.appendChild(knop);
        knoppenKleur.push(knop);
      });
    }

    /* ---------- maten ---------- */

    function bouwMaten() {
      if (!el.maten) return;
      el.maten.textContent = '';
      knoppenMaat = [];

      var rondGezet = false;
      maten.forEach(function (maat, i) {
        // Eén kopje boven de eerste ronde maat, zodat rechthoekig en rond niet
        // door elkaar lopen. Alleen als er ook rechthoekige maten vóór staan.
        if (maat.rond && !rondGezet && i > 0) {
          var kop = document.createElement('p');
          kop.className = 'lf-kleed-matenkop';
          kop.textContent = 'Rond';
          el.maten.appendChild(kop);
          rondGezet = true;
        }

        var knop = document.createElement('button');
        knop.type = 'button';
        knop.className = 'lf-kleed-maat';
        knop.setAttribute('aria-pressed', 'false');
        knop.dataset.waarde = maat.waarde;

        var naam = document.createElement('span');
        naam.textContent = maat.waarde;
        knop.appendChild(naam);

        var prijs = prijsVanMaat(maat.waarde);
        if (prijs !== null) {
          var bedrag = document.createElement('small');
          bedrag.textContent = geld(prijs);
          knop.appendChild(bedrag);
        }

        if (!heeftIets(iMaat, maat.waarde)) {
          knop.dataset.uit = 'true';
          knop.disabled = true;
        }

        knop.addEventListener('click', function () {
          if (knop.disabled) return;
          keuze.maat = maat.waarde;
          teken();
        });

        el.maten.appendChild(knop);
        knoppenMaat.push(knop);
      });
    }

    /* ---------- beginkeuze ---------- */

    function kiesBegin() {
      // De eerste variant die Shopify leverbaar noemt; anders gewoon de eerste.
      var start = null;
      for (var i = 0; i < data.varianten.length; i++) {
        if (data.varianten[i].beschikbaar) { start = data.varianten[i]; break; }
      }
      if (!start) start = data.varianten[0];
      keuze.kleur = start.waarden[iKleur];
      keuze.maat = start.waarden[iMaat];
    }

    /* ---------- tekenen ---------- */

    function teken() {
      var kleur = kleurGegevens(keuze.kleur);
      var variant = variantVoor(keuze.kleur, keuze.maat);

      knoppenKleur.forEach(function (knop) {
        knop.setAttribute('aria-pressed', knop.dataset.waarde === keuze.kleur ? 'true' : 'false');
      });
      knoppenMaat.forEach(function (knop) {
        knop.setAttribute('aria-pressed', knop.dataset.waarde === keuze.maat ? 'true' : 'false');
      });

      if (el.gekozenKleur) el.gekozenKleur.textContent = keuze.kleur || '';
      if (el.gekozenMaat) el.gekozenMaat.textContent = keuze.maat || '';

      // Kaart met de gekozen kleur groot.
      if (el.kaart) {
        el.kaart.hidden = false;
        if (el.kaartBeeld) {
          el.kaartBeeld.textContent = '';
          if (kleur.foto) {
            var kb = document.createElement('img');
            kb.src = kleur.foto;
            kb.alt = '';
            el.kaartBeeld.appendChild(kb);
          }
        }
        if (el.kaartNaam) el.kaartNaam.textContent = keuze.kleur || '';
        if (el.kaartMeta) {
          el.kaartMeta.textContent = kleur.foto
            ? 'Kleurstaal'
            : 'Staalfoto volgt — vraag ons gerust om een foto van deze kleur.';
        }
        if (el.kaartLoep) el.kaartLoep.hidden = !kleur.groot;
      }

      // Samenvatting onder het beeld.
      if (el.combiKleurStaal) {
        el.combiKleurStaal.textContent = '';
        if (kleur.foto) {
          var cb = document.createElement('img');
          cb.src = kleur.foto;
          cb.alt = '';
          el.combiKleurStaal.appendChild(cb);
        }
      }
      if (el.combiKleurNaam) el.combiKleurNaam.textContent = keuze.kleur || '—';
      if (el.combiMaatNaam) el.combiMaatNaam.textContent = keuze.maat || '—';

      if (el.samenvatting) {
        el.samenvatting.textContent = '';
        // Geen artikelnummer in de samenvatting: opgave eigenaar 03-08-2026.
        // De SKU staat ook niet meer in het datablok, dus niet in de paginabron.
        rij(el.samenvatting, 'Kleur', keuze.kleur || '—');
        rij(el.samenvatting, 'Maat', keuze.maat || '—');
      }

      // Prijs en bestelknop. Bestaat de combinatie niet, dan liever een
      // duidelijke melding dan een knop die een fout oplevert bij Shopify.
      var bedrag = variant ? variant.prijs : prijsVanMaat(keuze.maat);
      if (el.prijs && bedrag !== null && bedrag !== undefined) el.prijs.textContent = geld(bedrag);
      if (el.totaal && bedrag !== null && bedrag !== undefined) el.totaal.textContent = geld(bedrag);
      if (el.mobielTotaal && bedrag !== null && bedrag !== undefined) el.mobielTotaal.textContent = geld(bedrag);

      if (el.variantId) el.variantId.value = variant ? variant.id : '';
      if (el.bestel) el.bestel.disabled = !variant;
      if (el.melding) {
        if (!variant) {
          el.melding.hidden = false;
          el.melding.textContent = 'Deze combinatie van kleur en maat staat niet in de prijslijst. Kies een andere maat of neem contact met ons op.';
        } else if (!variant.beschikbaar) {
          // Deze producten worden op bestelling gemaakt; voorraad wordt niet
          // bijgehouden. Dit is dus een uitzondering, geen normale toestand.
          el.melding.hidden = false;
          el.melding.textContent = 'Deze uitvoering is tijdelijk niet te bestellen. Neem gerust contact met ons op.';
        } else {
          el.melding.hidden = true;
          el.melding.textContent = '';
        }
      }

      // Het hoofdbeeld volgt de kleur: klikt iemand op een staal, dan wil hij
      // die kleur zien. Eerst de afbeelding van de variant zelf — die is in
      // Shopify aan de variant gekoppeld en is dus de bron van waarheid; pas
      // als die ontbreekt het staal uit de productmedia. Is er geen van beide,
      // dan blijft het sfeerbeeld staan — en bij het laden van de pagina
      // sowieso, zie de opmerking bij `geklikt`.
      var beeld = (variant && variant.beeld) || kleur.groot;
      if (geklikt && el.hoofdbeeld && beeld) {
        el.hoofdbeeld.src = beeld;
        el.hoofdbeeld.alt = kleur.alt || keuze.kleur || '';
        markeerStrip(beeld);
      }
    }

    function rij(lijst, naam, waarde) {
      var dt = document.createElement('dt');
      dt.textContent = naam;
      var dd = document.createElement('dd');
      dd.textContent = waarde;
      lijst.appendChild(dt);
      lijst.appendChild(dd);
    }

    function markeerStrip(url) {
      if (!el.strip) return;
      el.strip.querySelectorAll('button').forEach(function (knop) {
        knop.setAttribute('aria-current', knop.dataset.lfThumb === url ? 'true' : 'false');
      });
    }

    /* ---------- galerij ---------- */

    if (el.strip) {
      el.strip.addEventListener('click', function (gebeurtenis) {
        var knop = gebeurtenis.target.closest('button[data-lf-thumb]');
        if (!knop || !el.hoofdbeeld) return;
        el.hoofdbeeld.src = knop.dataset.lfThumb;
        var beeld = knop.querySelector('img');
        el.hoofdbeeld.alt = beeld ? beeld.alt : '';
        markeerStrip(knop.dataset.lfThumb);
      });
    }

    /* ---------- vergrootlaag ---------- */

    function openLaag() {
      var kleur = kleurGegevens(keuze.kleur);
      if (!el.laag || !kleur.groot) return;
      if (el.laagBeeld) {
        el.laagBeeld.textContent = '';
        var beeld = document.createElement('img');
        beeld.src = kleur.groot;
        beeld.alt = kleur.alt || keuze.kleur || '';
        el.laagBeeld.appendChild(beeld);
      }
      if (el.laagNaam) el.laagNaam.textContent = keuze.kleur || '';
      el.laag.hidden = false;
      if (el.laagSluit) el.laagSluit.focus();
    }

    function sluitLaag() {
      if (!el.laag) return;
      el.laag.hidden = true;
      if (el.kaartLoep) el.kaartLoep.focus();
    }

    if (el.kaartLoep) el.kaartLoep.addEventListener('click', openLaag);
    if (el.laagSluit) el.laagSluit.addEventListener('click', sluitLaag);
    if (el.laag) {
      el.laag.addEventListener('click', function (gebeurtenis) {
        if (gebeurtenis.target === el.laag) sluitLaag();
      });
    }
    document.addEventListener('keydown', function (gebeurtenis) {
      if (gebeurtenis.key === 'Escape' && el.laag && !el.laag.hidden) sluitLaag();
    });

    /* ---------- mobiele balk ---------- */
    // Verschijnt zodra de bestelknop uit beeld is; dan is de knop onderin de
    // enige manier om te bestellen zonder terug te scrollen.
    if (el.mobiel && el.bestel && 'IntersectionObserver' in window) {
      var kijker = new IntersectionObserver(function (waarnemingen) {
        waarnemingen.forEach(function (waarneming) {
          el.mobiel.dataset.zichtbaar = waarneming.isIntersecting ? 'false' : 'true';
        });
      }, { rootMargin: '0px 0px -40px 0px' });
      kijker.observe(el.bestel);
    }

    /* ---------- opstarten ---------- */
    bouwStalen();
    bouwMaten();
    kiesBegin();
    teken();
  }

  /* Bedragen komen in centen uit Shopify. Intl doet de opmaak; valt dat weg,
     dan een eenvoudige terugval zodat er nooit "123400" op een knop staat. */
  function maakGeld(valuta, taal) {
    var opmaak;
    try {
      opmaak = new Intl.NumberFormat(taal || 'nl-NL', {
        style: 'currency',
        currency: valuta || 'EUR',
        minimumFractionDigits: 2
      });
    } catch (fout) {
      opmaak = null;
    }
    return function (centen) {
      var bedrag = (centen || 0) / 100;
      return opmaak ? opmaak.format(bedrag) : '€ ' + bedrag.toFixed(2);
    };
  }
})();
